import { BookmarkBorderOutlined, Facebook, LinkedIn, Twitter } from '@material-ui/icons'
import React from 'react'

const SocialIcons = () => {
  return (
    <div>
      <Facebook />
      <Twitter />
      <LinkedIn />
      <BookmarkBorderOutlined />
    </div>
  )
}

export default SocialIcons
